import themeDefaults from "../config/themeDefaults";

const THEME_CSS_VARS = {
  tabActiveColor: "--tab-active-color",
  tabActiveGradientStart: "--tab-active-gradient-start",
  tabActiveGradientEnd: "--tab-active-gradient-end",
  mineVipBoxGradientStart: "--mine-vip-box-gradient-start",
  mineVipBoxGradientEnd: "--mine-vip-box-gradient-end",
  mineVipRightGradientStart: "--mine-vip-right-gradient-start",
  mineVipRightGradientEnd: "--mine-vip-right-gradient-end",
  brandPrimary: "--brand-primary",
  brandGradientStart: "--brand-gradient-start",
  brandGradientEnd: "--brand-gradient-end",
  episodeActiveColor: "--episode-active-color",
  payGradientStart: "--pay-gradient-start",
  payGradientEnd: "--pay-gradient-end",
  modalBtnGradientStart: "--modal-btn-gradient-start",
  modalBtnGradientEnd: "--modal-btn-gradient-end",
  discountGradientStart: "--discount-gradient-start",
  discountGradientEnd: "--discount-gradient-end",
};

export function mergeTheme(configTheme = {}) {
  return { ...themeDefaults, ...configTheme };
}

export function applyThemeVars(configTheme = {}) {
  const theme = mergeTheme(configTheme);
  const root = document.documentElement;
  Object.entries(THEME_CSS_VARS).forEach(([key, cssVar]) => {
    const value = theme[key];
    if (value != null && value !== "") {
      root.style.setProperty(cssVar, value);
    }
  });
  if (theme.tabActiveUseGradient) {
    root.classList.add("theme-tab-gradient");
  } else {
    root.classList.remove("theme-tab-gradient");
  }
  return theme;
}
